const createRequestException = (e) => {
  throw e
}

export { createRequestException }
